var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layer-overlay",class:[_vm.environmentClass, _vm.environmentClass === 'stage' ? 'btn-primary' : 'btn-danger']},[_c('strong',[_vm._v(_vm._s(_vm.environmentText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }